import { createFileRoute } from '@tanstack/react-router';
import { UserDetail } from '@/components/users/UserDetail';
import { Button } from '@ouropix/ui';
import { ArrowLeft } from 'lucide-react';
import { Link } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/usuarios/$id')({
  component: UserDetailPage,
});

function UserDetailPage() {
  const { id } = Route.useParams();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="outline" size="sm" asChild>
          <Link to="/usuarios">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Voltar
          </Link>
        </Button>
        <div>
          <h1 className="text-2xl font-bold">Detalhes do Usuário</h1>
          <p className="text-muted-foreground text-sm font-mono break-all">ID: {id}</p>
        </div>
      </div>

      <UserDetail userId={id} />
    </div>
  );
}
